/****************************************************************************
Match Height JS
****************************************************************************/

function matchHeights(selector) {
  const elements = document.querySelectorAll(selector);
  let maxHeight = 0;

  // Reset heights first
  elements.forEach(el => {
    el.style.height = 'auto';
  });

  // Get the max height
  elements.forEach(el => {
    const height = el.offsetHeight;
    if (height > maxHeight) maxHeight = height;
  });

  // Apply the max height
  elements.forEach(el => {
    el.style.height = maxHeight + 'px';
  });
}

const selectors = [
  '.product-card-wrapper .card__heading',
  '.testimonial-title',
  '.testimonial-text',
];

function applyHeightMatching() {
  selectors.forEach(selector => matchHeights(selector));
}

document.addEventListener("DOMContentLoaded", applyHeightMatching);
window.addEventListener("resize", applyHeightMatching);

// Fallback for window resize
window.addEventListener("resize", () => {
  setTimeout(() => applyHeightMatching(), 100);
});


// Header
// function handleDetailsOpen() {
//   const details = document.querySelector('.header__search > details');
//   if (!details) return;

//   const isDesktop = window.innerWidth > 1199;

//   if (isDesktop) {
//     if (!details.hasAttribute('open')) {
//       details.setAttribute('open', '');
//     }
//   } else {
//     // Mobile: ensure it’s closed
//     details.removeAttribute('open');
//   }
// }

// // --- Run on load ---
// window.addEventListener('load', handleDetailsOpen);

// // --- Run on resize (debounced) ---
// let resizeTimeout;
// window.addEventListener('resize', function () {
//   clearTimeout(resizeTimeout);
//   resizeTimeout = setTimeout(handleDetailsOpen, 100);
// });

// // --- Run on scroll (debounced) to restore open state on desktop ---
// let scrollTimeout;
// window.addEventListener('scroll', function () {
//   clearTimeout(scrollTimeout);
//   scrollTimeout = setTimeout(function () {
//     const details = document.querySelector('.header__search > details');
//     if (!details) return;

//     if (window.innerWidth > 1199 && !details.hasAttribute('open')) {
//       details.setAttribute('open', '');
//     }
//   }, 150);
// });

// // --- Debug: Observe open/close for testing (optional) ---
// const debugDetails = document.querySelector('.header__search > details');
// if (debugDetails) {
//   const observer = new MutationObserver((mutationsList) => {
//     for (const mutation of mutationsList) {
//       if (mutation.attributeName === 'open') {
//         console.log('[Debug] `<details>` open attribute changed:', mutation.target);
//       }
//     }
//   });
//   observer.observe(debugDetails, { attributes: true });
// }


document.querySelectorAll('.header__inline-menu ul.list-menu.list-menu--inline details').forEach(item => {
  item.addEventListener('mouseenter', () => {
    item.setAttribute('open', true);
    item.querySelector('summary').setAttribute('aria-expanded', 'true');
  });

  item.addEventListener('mouseleave', () => {
    item.removeAttribute('open');
    item.querySelector('summary').setAttribute('aria-expanded', 'false');
  });
});